import React from 'react'

import { AdministrationForm } from '../..'

// Queries
import {
  READ_CHANGE_REFILL_MOTIVES,
  CREATE_CHANGE_REFILL_MOTIVES,
  UPDATE_CHANGE_REFILL_MOTIVES,
  LIST_CHANGE_REFILL_MOTIVES,
} from './queries'

const queries = {
  read: READ_CHANGE_REFILL_MOTIVES,
  create: CREATE_CHANGE_REFILL_MOTIVES,
  update: UPDATE_CHANGE_REFILL_MOTIVES,
  list: LIST_CHANGE_REFILL_MOTIVES,
}

const AdministrationFormLubricantChangeRefillMotives = () => (
  <AdministrationForm name={'motivo cambio o relleno'} queries={queries} />
)

export default AdministrationFormLubricantChangeRefillMotives
